<template>
    <div>
        <div class="full-screen" v-if="!isMobile">
            <FilterGroup />
        </div>
        <div class="mobile" v-if="isMobile">
            <FilterMobile />
        </div>
    </div>
</template>

<script setup>
    const { isMobile } = useMobile()
</script>
